import type { Ref } from 'react'
import { Link as RRLink, type LinkProps } from 'react-router-dom'

type Href =
  | string
  | {
      pathname?: string
      query?: Record<string, string | number | undefined | null>
    }

function hrefToTo(href: Href): string {
  if (typeof href === 'string') return href
  const params = new URLSearchParams()
  if (href.query) {
    for (const [k, v] of Object.entries(href.query)) {
      if (v != null && v !== '') params.set(k, String(v))
    }
  }
  const q = params.toString()
  return (href.pathname ?? '') + (q ? `?${q}` : '')
}

/** Next.js-style Link (`href`) on top of react-router. */
export function Link({
  href,
  to,
  ref,
  ...rest
}: { href?: Href; to?: string; ref?: Ref<HTMLAnchorElement> } & Omit<
  LinkProps,
  'to'
>) {
  return <RRLink ref={ref} to={to ?? hrefToTo(href!)} {...rest} />
}
